// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Z7pa","footer__items":"styles_footer__items__5k5vJ","footer__count":"styles_footer__count__rBChZ"};